<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Page Title Section -->
  <div class="page-title-section">
    <h2>Assurance Retraite Complémentaire Professionnelle</h2>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <p>
      Si vous êtes à la recherche de ce type d'assurance <span class="text-purple">Retraite Complémentaire Professionnelle</span>, merci de prendre contact avec nous car il existe beaucoup trop de déclinaisons selon votre situation personnelle.
    </p>
  </div>

  <!-- Partner Section -->
  <div class="main-content">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <span class="text-purple">GENERALI, SWISSLIFE, ALPTIS, MALAKOFF HUMANIS...</span>
    </p>
  </div>

  <!-- Contact Button -->
  <div class="contact-button-wrapper">
    <button class="btn-contact" (click)="navigateToContact()">
      Contactez-nous
    </button>
  </div>

</app-page-layout>
